import React, {useEffect, useContext } from 'react';
import { AppContext, AuthContext } from 'core/context/';
import { getLibraries } from 'services/commonServices';

const Hidden = () => {
  const { isUserLoggedIn } = useContext(AuthContext);
  const { updateAppContext } = useContext(AppContext);

  useEffect(() => {
    if(isUserLoggedIn){
      getLibraries().then(({response, error}) => {
        if(response) {
          updateAppContext({libraries: [...response]});
        }
      })
    }
  }, [isUserLoggedIn])
  
  
  return null;
}
 
export default React.memo(Hidden);
